var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.146,
    cy: 12,
    r: 12,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.053 17H12.7975V11.9564H14.016L14.146 10.2682H12.8006C12.8006 10.2682 12.8006 9.6369 12.8006 9.30555C12.8006 8.90792 12.8701 8.75096 13.2027 8.75096C13.4718 8.75096 14.146 8.75096 14.146 8.75096V7C14.146 7 13.1513 7 12.9366 7C11.6396 7 11.053 7.65923 11.053 8.92187C11.053 10.0206 11.053 10.2682 11.053 10.2682H10.146V11.9773H11.053V17Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b9cf576043880886076cb2146fa9cf50.svg";
export { ForwardRef as ReactComponent };